















































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { auth, staff as info } from "@/config/host.config";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { deleteElement } from "@/api/delite/delite-element";
import { GuestRules } from "@/api/AuthAPI/user-role";
import { IActivityStatus } from "@/@types/admin/activity-status";
import { IStaff } from "@/@types/admin/staff";

import RoomForm from "@/components/forms/room/room-form.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import RoomList from "@/components/administration/hotel/room/room-list.vue";
import HotelConfiguration from "@/components/administration/hotel/hotel-configuration.vue";
import HotelConstructor from "@/components/administration/hotel/hotel-constructor.vue";
import RoomControlSettings from "@/components/administration/hotel/room-control-settings.vue";

@Component({
  components: {
    ButtonBack,
    RoomList,
    RoomForm,
    HotelConfiguration,
    HotelConstructor,
    RoomControlSettings,
  },
})
export default class HotelAdministration extends Vue {
  @Provide("mainPhotoFolder") mainPhotoFolder = "room/main_photo";
  @Provide("roomGalleryFolder") roomGalleryFolder = "room/gallery";
  @Provide("roomPlanFolder") roomPlanFolder = "room/room_plan";
  @Provide("firePlanFolder") firePlanFolder = "room/fire_plan";

  roomDeleted = false;
  controlDeleted = false;
  showConstructor = false;
  levelID = 0;

  statuses: Array<IRoomControl> = [];
  types: Array<IRoomControl> = [];
  levels: Array<IRoomControl> = [];
  rooms: Array<IRoom> = [];
  tvs: Array<IActivityStatus> = [];
  devices: Array<IActivityStatus> = [];
  staffs: Array<IStaff> = [];
  roomsLoaded = false;

  control_id = "";
  room_id = "";

  get room(): IRoom | null {
    const st = this.rooms.find((el) => el._id == this.room_id);
    return st ? st : null;
  }

  get showEmpty(): boolean {
    return this.roomsLoaded && this.rooms.length === 0 && !this.roomDeleted;
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  openConstructor(): void {
    this.showConstructor = true;
    this.$nextTick(() => {
      this.$bvModal.show("constructor");
    });
  }

  closeConstructor(): void {
    this.$bvModal.hide("constructor");
    this.$nextTick(() => {
      this.showConstructor = false;
      this.room_id = "";
    });
  }

  @Watch("controlDeleted")
  startControl(): void {
    this.getRoomStatuses();
    this.getRoomTypes();
    this.getRoomLevels();
  }

  mounted(): void {
    this.startControl();
    this.getRoomList();
    this.getTVList();
    this.getDeviceList();
    this.getStaffList();
  }

  async restoreStatus(id: string): Promise<void> {
    if (!id) return;
    const uri = auth.restore_room_status + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.statuses.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomTypes();
        this.statuses.splice(i, 1);
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async restoreType(id: string): Promise<void> {
    if (!id) return;
    const uri = auth.restore_room_type + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.types.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomTypes();
        this.types.splice(i, 1);
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async restoreLevel(id: string): Promise<void> {
    if (!id) return;
    const uri = auth.restore_room_level + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.levels.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomLevels();
        this.levels.splice(i, 1);
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async getRoomStatuses(): Promise<void> {
    const uri = auth.room_status;
    const params = { "match[deleted][value]": this.controlDeleted };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.statuses = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  async getRoomTypes(): Promise<void> {
    const uri = auth.room_type;
    const params = { "match[deleted][value]": this.controlDeleted };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.types = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  async getRoomLevels(): Promise<void> {
    const uri = auth.room_level;
    const params = { "match[deleted][value]": this.controlDeleted };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.levels = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  async getTVList(): Promise<void> {
    const uri = auth.getUser;
    const params = { rules: GuestRules.tvuser };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.tvs = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  async getDeviceList(): Promise<void> {
    const uri = auth.getUser;
    const params = { rules: GuestRules.tabuser };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.devices = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  async getStaffList(): Promise<void> {
    const uri = info.staff;
    const params = { "match[deleted][value]": false };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.staffs = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  async staffChange(date: Partial<IStaff>): Promise<void> {
    const url = info.staff;
    try {
      const res = await this.$axios.post(url, date);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$bvModal.hide("add-staff");
        this.staffs.push(res.data);
      }
    } catch (e) {
      this.onError();
      console.log(e);
    }
  }

  async restoreRoom(id: string): Promise<void> {
    if (!id) return;
    const uri = auth.restore_room + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        const i = this.rooms.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomList();
        this.rooms.splice(i, 1);
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async repositionRoom(room: IRoom, x: number, y: number): Promise<void> {
    if (!room || !room._id) return;
    const position = { x: String(x), y: String(y), z: room.level };
    const uri = auth.room + "/" + room._id;
    try {
      const res = await this.$axios.put(uri, { position });
      if (res.status === 200) {
        const i = this.rooms.findIndex((r) => r._id === room._id);
        if (i >= 0) {
          this.$set(this.rooms, i, { ...this.rooms[i], position });
        }
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async changeRoom(data: Partial<IRoom>, id: string): Promise<void> {
    const uri = id ? auth.room + "/" + id : auth.room;
    const method = id ? "put" : "post";
    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.closeConstructor();
        this.room_id = "";
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (id) {
          const i = this.rooms.findIndex((el) => el._id == this.control_id);
          if (i < 0) return this.getRoomList();
          this.$set(this.rooms, i, data);
        } else this.rooms.push(res.data);
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async changeElement(
    data: Partial<IRoomControl>,
    id: string,
    tabIndex: number
  ): Promise<void> {
    let uri =
      tabIndex == 0
        ? auth.room_status
        : tabIndex == 1
        ? auth.room_type
        : auth.room_level;
    if (id) uri += "/" + id;
    const method = id ? "put" : "post";
    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.$bvModal.hide("room-control");
        this.control_id = "";
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (id) {
          const arr =
            tabIndex == 0
              ? this.statuses
              : tabIndex == 1
              ? this.types
              : this.levels;
          const i = arr.findIndex((el) => el._id == this.control_id);
          if (i < 0) return this.startControl();
          this.$set(arr, i, data);
        } else {
          if (tabIndex == 0) this.statuses.push(res.data);
          else if (tabIndex == 1) this.types.push(res.data);
          else this.levels.push(res.data);
        }
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  dropDB(): void {
    for (const el of this.rooms) {
      this.deletedRoom(el._id);
    }
  }

  deletedRoom(id: string): void {
    const uri = this.roomDeleted ? auth.force_room : auth.room;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.rooms.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomList();
        this.rooms.splice(i, 1);
      })
      .catch((e) => {
        this.onError();
        console.error(e);
      });
  }

  deleteStatus(id: string): void {
    const uri = this.controlDeleted ? auth.force_room_status : auth.room_status;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.statuses.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomStatuses();
        this.statuses.splice(i, 1);
      })
      .catch((e) => {
        console.error(e);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  deleteType(id: string): void {
    const uri = this.controlDeleted ? auth.force_room_type : auth.room_type;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.types.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomTypes();
        this.types.splice(i, 1);
      })
      .catch((e) => {
        console.error(e);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  deleteLevel(id: string): void {
    const uri = this.controlDeleted ? auth.force_room_level : auth.room_level;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.levels.findIndex((el) => el._id == id);
        if (i < 0) return this.getRoomLevels();
        this.levels.splice(i, 1);
      })
      .catch((e) => {
        console.error(e);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  @Watch("roomDeleted")
  async getRoomList(): Promise<void> {
    const uri = auth.room;
    const params = { "match[deleted][value]": this.roomDeleted };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.rooms = res.data;
    } catch (e) {
      console.error(e);
    } finally {
      this.roomsLoaded = true;
    }
  }
}
